<template>
  <div class="container text-left">
      <div class="row justify-content-md-center">
        <div class="col-lg-5">
          <div v-if="confirmed">
                Thank you for confirming your email.  You can login <router-link to="/">here</router-link>.
            </div>
            <div v-else>
                {{ error.message }}
              <form @submit.prevent="resendCode" v-if="error.code === 'ExpiredCodeException'">
                  <b-form-group>
                      <b-form-input id="email" v-model="formEmail" placeholder="Email" type="text" :state="submitted && $v.formEmail.$error ? false : null" />
                      <b-form-invalid-feedback v-if="submitted && !$v.formEmail.required">Email is required</b-form-invalid-feedback>
                      <b-form-invalid-feedback v-if="submitted && !$v.formEmail.email">Email needs to be a valid email</b-form-invalid-feedback>
                  </b-form-group>
                  <b-button type=submit :disabled="submitted && $v.$invalid">Resend Code</b-button>
              </form>
          </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  required, email,
} from 'vuelidate/lib/validators';

export default {
  data() {
    return {
      confirmed: null,
      error: {},
      formEmail: null,
      submitted: false,
    };
  },
  validations: {
    formEmail: {
      required,
      email,
    },
  },
  props: {
    email: String,
    code: String,
  },
  mounted() {
    this.formEmail = this.email;
    this.$store.dispatch('auth/confirmRegistration', {
      username: this.email,
      code: this.code,
    }).then(() => {
      this.confirmed = true;
    }).catch((err) => {
      this.confirmed = false;
      this.error = err;
    });
  },
  methods: {
    resendCode() {
      this.submitted = true;
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }

      this.$store.dispatch('auth/resendConfirmationCode', {
        username: this.formEmail,
      }).then(() => {
        this.error = {
          code: 'confirmationResent',
          message: 'Please check your email for a new confirmation code.',
        };
      }).catch((err) => {
        this.error = err;
      });
    },
  },
};
</script>

<style>

</style>
